// eslint-disable-next-line max-classes-per-file
import { Moment } from 'moment/moment'
import { VALIDATOR_ERROR_MESSAGE } from 'Modules'
import { Calendar, TYPE_ORGANIZATION } from 'Pages/ibro'

export class ValidationError {
	public message = ''
	public code?: string
}

export class ValidatorResult {
	public result = false
	public error = new ValidationError()
}

export type ValidateInnPayload = {
	isTwelve?: boolean
}

export type ValidationDate = string | Moment

export type MessageErrorType = Partial<Record<VALIDATOR_ERROR_MESSAGE, string>>

type RequiredKeys<
	T,
	R = { [P in keyof T]: Pick<T, P> extends Required<Pick<T, P>> ? P : undefined }
> = T extends Record<string, unknown> ? R[keyof R] : undefined

export type ValidatorOptions<
	Payload extends Partial<Record<string, unknown>> | null = null,
	PayloadKeys = Payload extends string
		? undefined
		: Exclude<RequiredKeys<Payload>, undefined> extends never
		? undefined
		: Exclude<RequiredKeys<Payload>, undefined>
> = {
	required?: boolean
	messageError?: string | MessageErrorType
	format?: string
} & (PayloadKeys extends undefined ? { payload?: Payload } : { payload: Payload })

export type ValueType = string | number | Moment | File | boolean

export type ValidateSizeVideoPayload = {
	minWidth: number
	minHeight: number
}

export type LengthValidatorPayload = {
	length: number
}

export type ValidateMoreDatePayload = {
	min: ValidationDate
}

export type ValidateLessDatePayload = {
	max: ValidationDate
}

export type ValidateLessMoreDatePayload = {
	from?: ValidationDate
	to?: ValidationDate
	daysCount?: number
}

export type ValidateMaxLengthPayload = {
	max: number
}

export type SearchTextValidatorPayload = {
	text: string
	isRegister?: boolean
	isOnlyBegin?: boolean
}

export type ValidateAgePayload = {
	age?: number
	maxAge?: number
}
export type ValidatePassportIntervalPayload = {
	birthDate: ValidationDate
}

export type validateIfNumberExistsPayload = {
	array: string[]
}

export type validateIfDateExistInPayloadType = {
	array: Calendar[]
}

export type IkzOptions = {
	inn: string
	kpp: string
}

export type RegexOptions = {
	regex: RegExp
}

export type LengthOptions = {
	max?: number
	min?: number
}

export type EqualTextOptions = {
	text: string
	register?: boolean
}

export type IncludesTextOptions = {
	text?: string
	orgType?: TYPE_ORGANIZATION
}

export type HouseAddressOptions = {
	key: string
	value: string
}
export type AntValidator = (
	rule: any,
	value: any,
	callback: any,
	source?: any,
	options?: any
) => any
